import { SoftSkillsActionTypes } from './SoftSkills.action';

const initialState = {
    loading: false,
    softSkillsChallenge: {},
    error: null,
    currentScreen: '',
    takenSoftSkills: false
};

function SoftSkillsReducer(state = initialState, action) {
    switch (action.type) {
        case SoftSkillsActionTypes.FETCH_SOFT_SKILLS_STATUS:
            return { ...state, loading: true, error: null };
        case SoftSkillsActionTypes.FETCH_SOFT_SKILLS_STATUS_SUCCESS:
            if (action.payload && action.payload.challengeId && action.payload.currentState && action.payload.currentState.state) {
                if (action.payload.currentState.state === 'TODO') {
                    return { 
                        ...state, 
                        softSkillsChallenge: action.payload, 
                        loading: false, 
                        currentScreen: 'landing',
                        takenSoftSkills: false
                    };
                } else {
                    return { 
                        ...state, 
                        softSkillsChallenge: action.payload, 
                        loading: false, 
                        currentScreen: 'ontro',
                        takenSoftSkills: true
                    };
                }
            }
            return { ...state, softSkillsChallenge: action.payload, currentScreen: 'landing', loading: false, takenSoftSkills: false };
        case SoftSkillsActionTypes.FETCH_SOFT_SKILLS_STATUS_FAILURE:
            return { ...state, error: action.payload, loading: false, currentScreen: 'landing', takenSoftSkills: false };
        case SoftSkillsActionTypes.CONTINUE_TO_INTRO:
            return { ...state, currentScreen: 'intro' };
        case SoftSkillsActionTypes.CONTINUE_TO_LANDING:
            return { ...state, currentScreen: 'landing' };
        default:
            return state;
    }
}

export default SoftSkillsReducer;